import {
  BrowserRouter as Router,
  Route,
  Navigate,
  createRoutesFromElements,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import { useAppDispatch, useAppSelector } from "./app/hooks";
import Login from "./features/login/Login";
import { selectBackgroundImageUrl } from "./features/customization/customizationSlice";
import "./features/common/commonStyles.scss";
import { useCookies } from "react-cookie";

import { MagicForms } from "./features/services/magicforms/MagicForms";
import { Page404 } from "./features/Page404/Page404";
import { useEffect, useState } from "react";
import {
  getClientAndUserData,
  resetState,
  selectRoles,
  selectShouldResetPassword,
  selectTokenExpiryTimestamp,
  setTokenInfo,
} from "./features/common/commonSlice";
import { TemplatesComponent } from "./features/services/magicforms/magicComponents/TemplatesComponent";
import { FilledFormsComponent } from "./features/services/magicforms/magicComponents/FilledForms";
import { FilledFormsDetail } from "./features/services/magicforms/detail/FilledFormsDetail";
import { TemplateDetail } from "./features/services/magicforms/detail/TemplateDetail";
import { CoreId } from "./features/services/coreid/CoreId";
import { Registrations } from "./features/services/coreid/coreIdComponents/Registrations";
import { Registration } from "./features/services/coreid/detail/Registration";
import { UnifiedAlerts } from "./features/services/alerts/UnifiedAlerts";
import { CoreIdAlerts } from "./features/services/coreid/coreIdComponents/CoreIdAlerts";
import { FirmaElectronicaNew } from "./features/services/firmanew/FirmaElectronicaNew";
import { FirmasNew } from "./features/services/firmanew/firmaComponents/Firmas";
import { DetailFirmaNew } from "./features/services/firmanew/detail/FirmaNewDetail";
import { HyperFlow } from "./features/services/hyperFlow/HyperFlow";
import { SignerDetail } from "./features/services/firmanew/detail/SignerDetail";
import axiosApiInstance from "./helpers/interceptor";
import localforage from "localforage";
import { ConsultaManual } from "./features/services/coreid/coreIdComponents/ConsultaManual";
import { Introv2 } from "./features/intro/introd";
import { FlowsList } from "./features/services/hyperFlow/hyperFlowComponents/FlowsList";
//import { Flowv2 } from "./features/services/hyperFlow/detail/Flowv2";
import { HyperFlowDetail } from "./features/services/hyperFlow/HyperFlowDetail";
//import { Flowv3 } from "./features/services/hyperFlow/detail/Flowv3";
import { ListBusquedas } from "./features/services/components/ListBusquedas";
import { IntroSearch } from "./features/intro/introSearch";
import { Flowv2 } from "./features/services/hyperFlow/detail/Flowv2";
import { SmartFlow } from "./features/services/smartflow/SmartFlow";
import { Flows } from "./features/services/smartflow/smartFlowComponents/Flows";
import { Flow } from "./features/services/smartflow/detail/Flow";
import { Pagares } from "./features/services/pagares/Pagares";
import { PagaresList } from "./features/services/pagares/pagareComponents/PagaresList";
import { DetailPagare } from "./features/services/pagares/detail/PagareDetail";
import { PagareFill } from "./features/services/pagares/detail/PagareFill";
import { PagareEndoso } from "./features/services/pagares/detail/PagareEndoso";
import { PagareCreate } from "./features/services/pagares/detail/PagareCreate";
import { Configuration } from "./features/configuration/Configuration";
import { Account } from "./features/configuration/configurationComponents/Account";
import { Users } from "./features/configuration/configurationComponents/Users";
import { UserDetail } from "./features/configuration/configurationComponents/UserDetail";
import { AnalyticsCoreId } from "./features/services/coreid/coreIdComponents/Analytics";
import { AnalyticsHyperFlow } from "./features/services/hyperFlow/hyperFlowComponents/Analytics";
import { AnalyticsMagicForms } from "./features/services/magicforms/magicComponents/Analytics";
import { AnalyticsFirma } from "./features/services/firmanew/firmaComponents/Analytics";
import { AnalyticsPagares } from "./features/services/pagares/pagareComponents/Analytics";
import { AnalyticsSmartFlow } from "./features/services/smartflow/smartFlowComponents/Analytics";
import { ResetPassword } from "./features/login/ResetPassword";
import { SubClients } from "./features/configuration/clients/Subclients";
import { SubClientDetail } from "./features/configuration/clients/SubClientDetail";
import { EditSubclient } from "./features/configuration/clients/EditSubclient";
import { CreateSubClient } from "./features/configuration/clients/CreateSubclient";
import { GeneralHelp } from "./features/configuration/help/GeneralHelp";
import { HyperflowHelp } from "./features/configuration/help/Hyperflow/HyperflowHelp";
import { LiveMonitoringPage } from "./features/services/liveMonitoring/LiveMonitoringPage";
import { ActionHistory } from "./features/configuration/configurationComponents/ActionHistory";
import { CoreIdHelp } from "./features/configuration/help/CoreId/CoreIdHelp";
import { MagicFormsHelp } from "./features/configuration/help/MagicForms/MagicFormsHelp";
import { PagaresHelp } from "./features/configuration/help/Pagares/PagaresHelp";
import { ConfiguracionHelp } from "./features/configuration/help/Configuracion/ConfiguracionHelp";
import { FirmaHelp } from "./features/configuration/help/Firma/FirmaHelp";
import { MfEditorPage } from "./features/services/magicforms/editor/MfEditorPage";
import { AuthentikatorProcessList } from "./features/services/authentikator/AuthentikatorProcessList";
import { AuthentikatorProcessDetail } from "./features/services/authentikator/AuthentikatorProcessDetail";
import { AuthentikatorSideBar } from "./features/services/authentikator/AuthentikatorSideBar";
import { DashboardClient } from "./features/services/repoteria/DashboardClient";
import { Reports } from "./features/services/repoteria/dashboardComponents/Reports";
import { Indicators } from "./features/services/repoteria/dashboardComponents/Indicators";
import { ConvertibilityFunnel } from "./features/services/repoteria/dashboardComponents/ConvertibilityFunnel";
import { Advisors } from "./features/services/repoteria/dashboardComponents/Advisors";
import { HfEditorPage } from "./features/services/hyperFlow/editor/HfEditorPage";
import { ModalEditorPage } from "./features/services/magicforms/editor/ModalEditorPage";
import { General } from "./features/services/facturacion/facturacionComponents/General";
import { Analytics } from "./features/services/facturacion/facturacionComponents/Analytics";
import { ReportsBilling } from "./features/services/facturacion/facturacionComponents/ReportsBilling";
import { Config } from "./features/services/facturacion/facturacionComponents/Config";
import { Billing } from "./features/services/facturacion/Billing";
import { CustomListsEditor } from "./features/services/hyperFlow/customLists/CustomListsEditor";
import Modal, { Styles } from "react-modal";
import {
  changePasswordData,
  changePasswordErrorData,
  resetOwnPassword,
  selectPasswordData,
  selectPasswordDataError,
  selectResetOwnPasswordLoading,
} from "./features/configuration/configurationSlice";
import { ClipLoader } from "react-spinners";
import { ReactComponent as EyeIcon } from "./Assets/common/images/eyePassword.svg";
import { ReactComponent as EyeOffIcon } from "./Assets/common/images/eyePasswordOff.svg";
import { Tooltip } from "./features/common/components/Tooltip";
import { ManualLists } from "./features/services/lists/ManualLists";
import { Consultations } from "./features/services/lists/listsComponents/Consultations";
import { ConsultationDetail } from "./features/services/lists/detailComponents/ConsultationDetail";
import MarcacionesStatsPage from "./features/services/marcacionesV2/MarcacionesStatsPage";
import { BillingConsumption } from "./features/services/repoteria/dashboardComponents/BillingConsumption";
import { OfflineConfig } from "./features/configuration/configurationComponents/OfflineConfig";
import { BillingReports } from "./features/services/repoteria/dashboardComponents/BillingReports";

Modal.setAppElement("#root");
const customStylesModalChangePassword: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "40%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
};
function App() {
  const baseNameFromEnv = import.meta.env.VITE_PUBLIC_URL || "/";
  let dispatch = useAppDispatch();
  let backgroundImage = useAppSelector(selectBackgroundImageUrl);
  let expiryTimestamp = useAppSelector(selectTokenExpiryTimestamp);
  let roles = useAppSelector(selectRoles);
  const shouldChagePassword = useAppSelector(selectShouldResetPassword);
  const passwordData = useAppSelector(selectPasswordData);
  const passwordDataError = useAppSelector(selectPasswordDataError);
  const passwordResetLoading = useAppSelector(selectResetOwnPasswordLoading);

  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [generalPasswordError, setGeneralPasswordError] = useState("");

  const [cookies, _, removeCookie] = useCookies(["token"]);

  const canChangePassword = () => {
    if (
      shouldChagePassword &&
      passwordDataError.newPasswordError === "" &&
      passwordDataError.newPasswordRepeatError === "" &&
      passwordData.newPassword &&
      passwordData.newPasswordRepeat
    ) {
      if (passwordData.newPassword === passwordData.newPasswordRepeat) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  let checkCookie = async () => {
    if (cookies.token && expiryTimestamp !== -1) {
      if (expiryTimestamp < new Date().getTime()) {
        dispatch(resetState());
        delete axiosApiInstance.defaults.headers.common["Authorization"];
        await localforage.clear();
        removeCookie("token", {
          path: "/",
          sameSite: "lax",
          secure: true,
        });
      }
    } else if (cookies.token && expiryTimestamp === -1) {
      dispatch(setTokenInfo(cookies.token));
    } else if (
      (!cookies || !cookies.token || cookies.token === "") &&
      expiryTimestamp !== -1
    ) {
      dispatch(resetState());
      delete axiosApiInstance.defaults.headers.common["Authorization"];
      await localforage.clear();
      if (cookies.token === "") {
        removeCookie("token", {
          path: "/",
          sameSite: "lax",
          secure: true,
        });
      }
    }
  };

  useEffect(() => {
    if (
      passwordDataError.newPasswordError === "" &&
      passwordDataError.newPasswordRepeatError === ""
    ) {
      if (passwordData.newPassword === passwordData.newPasswordRepeat) {
        setGeneralPasswordError("");
      } else {
        setGeneralPasswordError("Las contraseñas deben ser iguales");
      }
    } else {
      setGeneralPasswordError("");
    }
  }, [passwordData, passwordDataError]);

  useEffect(() => {
    const intervalCookies = setInterval(() => {
      checkCookie();
    }, 3000);
    return () => clearInterval(intervalCookies);
  }, [cookies, expiryTimestamp]);

  const routes = createRoutesFromElements(
    <>
      <Route
        path="mfEditor"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["magicforms.form.edit", "magicforms.admin"],
          <MfEditorPage />
        )}
      />
      <Route
        path="mfModalEditor"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["magicforms.form.edit", "magicforms.admin"],
          <ModalEditorPage />
        )}
      />

      <Route
        path="hfEditor"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["hfEditor", "hyperflow.admin", "editor.hyperflow"],
          <HfEditorPage />
        )}
      />
      <Route
        path="liveMonitoring"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["Admin.liveMonitoring"],
          <LiveMonitoringPage />
        )}
      ></Route>
      <Route path="/resetPassword" element={<ResetPassword />}></Route>
      <Route
        path="/"
        element={
          cookies.token && cookies.token !== "" ? (
            <Navigate to="/intro" />
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/login"
        element={
          !cookies.token || cookies.token === "" ? (
            <Login />
          ) : (
            <Navigate to="/intro" />
          )
        }
      />
      <Route
        path="/intro"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <Introv2 />
          )
        }
      >
        <Route path="intro" element={<Introv2 />} />
      </Route>
      <Route
        path="/configuration"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <Configuration />
          )
        }
      >
        <Route path="help/general" element={<GeneralHelp />}></Route>
        <Route path="help/hyperflow" element={<HyperflowHelp />}></Route>
        <Route path="help/coreid" element={<CoreIdHelp />}></Route>´
        <Route path="help/magicforms" element={<MagicFormsHelp />}></Route>
        <Route path="help/firma" element={<FirmaHelp />}></Route>
        <Route path="help/pagares" element={<PagaresHelp />}></Route>
        <Route
          path="help/configuracion"
          element={<ConfiguracionHelp />}
        ></Route>
        <Route path="account" element={<Account />}></Route>
        <Route
          path="actionHistory"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["users.admin", "users.audit"],
            <ActionHistory />
          )}
        ></Route>
        <Route
          path="users"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["users.view"],
            <Users />
          )}
        ></Route>
        <Route
          path="users/:id"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["users.view"],
            <UserDetail />
          )}
        />
        <Route
          path="offlineConfig"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["users.view"],
            <OfflineConfig />
          )}
        />
        <Route
          path="subclients"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["clients.view", "clients.admin"],
            <SubClients />
          )}
        />
        <Route
          path="subclients/:id"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["clients.view", "clients.admin"],
            <SubClientDetail />
          )}
        />
        <Route
          path="subclients/edit/:id"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["clients.view", "clients.admin", "clients.edit"],
            <EditSubclient />
          )}
        />
        <Route
          path="subclients/create"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["clients.view", "clients.admin", "clients.create"],
            <CreateSubClient />
          )}
        />
      </Route>
      <Route
        path="/search/"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <IntroSearch />
          )
        }
      >
        <Route path=":query" element={<ListBusquedas />} />
      </Route>
      <Route
        path="/services"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <Navigate to="/intro" />
          )
        }
      />
      <Route
        path="/services/coreId/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["coreid.view", "coreid.admin"],
          <CoreId />
        )}
      >
        <Route path="registrations" element={<Registrations />} />
        <Route path="registrations/:id" element={<Registration />} />
        {/* <Route path="flow" element={<Flujos />} /> */}
        <Route path="alerts" element={<CoreIdAlerts />} />
        <Route
          path="analytics"
          element={
            roles.includes("analytics.admin") ||
            roles.includes("analytics.coreid.view") ? (
              <AnalyticsCoreId />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="manualLists"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            ["lists.view", "lists.consult"],
            <ConsultaManual />
          )}
        />
      </Route>

      <Route
        path="/services/magicForms/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["magicforms.view", "magicforms.admin"],
          <MagicForms />
        )}
      >
        <Route path="templates" element={<TemplatesComponent />} />
        <Route path="filledForms" element={<FilledFormsComponent />} />
        <Route path="filledForms/:id" element={<FilledFormsDetail />} />
        <Route path="templates/:id" element={<TemplateDetail />} />
        <Route
          path="analytics"
          element={
            roles.includes("analytics.admin") ||
            roles.includes("analytics.magicforms.view") ? (
              <AnalyticsMagicForms />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Route>

      <Route
        path="/services/electronicSignatureNew/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["firma.view", "firma.admin"],
          <FirmaElectronicaNew />
        )}
      >
        <Route path="signatures" element={<FirmasNew />} />
        <Route path="signatures/:id" element={<DetailFirmaNew />} />
        <Route
          path="signatures/:id/signer/:signerId"
          element={<SignerDetail />}
        />
        <Route
          path="analytics"
          element={
            roles.includes("analytics.admin") ||
            roles.includes("analytics.firma.view") ? (
              <AnalyticsFirma />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Route>
      <Route
        path="/services/pagares/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["pagare.view"],
          <Pagares />
        )}
      >
        <Route path="list" element={<PagaresList />} />
        <Route path="list/:id" element={<DetailPagare />} />
        <Route path="fill/:id" element={<PagareFill />} />
        <Route path="endosar/:id" element={<PagareEndoso />} />
        <Route path="create" element={<PagareCreate />} />
        <Route
          path="analytics"
          element={
            roles.includes("analytics.admin") ||
            roles.includes("analytics.pagares.view") ? (
              <AnalyticsPagares />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Route>
      <Route
        path="/services/hyperFlow/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["hyperflow.view", "hyperflow.admin"],
          <HyperFlow />
        )}
      >
        <Route path="flows" element={<FlowsList />} />
        <Route
          path="analytics"
          element={
            roles.includes("analytics.admin") ||
            roles.includes("analytics.hyperflow.view") ? (
              <AnalyticsHyperFlow />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="customLists"
          element={
            roles.includes("hyperflow.admin") ? (
              <CustomListsEditor />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Route>

      <Route
        path="/services/hyperFlow/"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <HyperFlowDetail />
          )
        }
      >
        <Route path="flows/:id" element={<Flowv2 />} />
      </Route>
      <Route
        path="/services/smartFlow/"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <SmartFlow />
          )
        }
      >
        <Route path="flows" element={<Flows />} />
        <Route path="flows/:id" element={<Flow />} />
        <Route
          path="analytics"
          element={
            roles.includes("analytics.admin") ||
            roles.includes("analytics.smartflow.view") ? (
              <AnalyticsSmartFlow />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Route>

      <Route
        path="/services/authentikator/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["authentikator.view", "authentikator.admin"],
          <AuthentikatorSideBar />
        )}
      >
        <Route path="processes" element={<AuthentikatorProcessList />} />
        <Route path="processes/:id" element={<AuthentikatorProcessDetail />} />
      </Route>
      <Route
        path="services/alerts"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <UnifiedAlerts />
          )
        }
      />
      <Route
        path="/services/marcacionesV2/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["marcacionesV2.view", "marcacioncesV2.admin"],
          <MarcacionesStatsPage />
        )}
      ></Route>
      <Route
        path="services/alerts"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <UnifiedAlerts />
          )
        }
      />
      <Route
        path="/services/dashboardClient/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          [
            "dashboard.client.admin",
            "dashboard.client.view",
            "dashboard.internal.admin",
          ],
          <DashboardClient />
        )}
      >
        <Route path="reports" element={<Reports />} />
        <Route path="indicators" element={<Indicators />} />
        <Route path="convertibilityFunnel" element={<ConvertibilityFunnel />} />
        <Route path="advisors" element={<Advisors />} />
        <Route
          path="billingConsumption"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            [
              "dashboard.client.admin",
              "dashboard.internal.admin",
              "dashboard.client.billing",
            ],
            <BillingConsumption />
          )}
        />
        <Route
          path="billingReport"
          element={redirectBasedOnRolesOrCookies(
            cookies,
            roles,
            [
              "dashboard.client.admin",
              "dashboard.internal.admin",
              "dashboard.client.billing",
            ],
            <BillingReports />
          )}
        />
      </Route>
      <Route
        path="/services/manualLists"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["lists.view", "lists.admin"],
          <ManualLists />
        )}
      >
        <Route path="consultations" element={<Consultations />} />
        <Route path="consultations/:id" element={<ConsultationDetail />} />
      </Route>
      <Route
        path="/billing/"
        element={redirectBasedOnRolesOrCookies(
          cookies,
          roles,
          ["billing.view", "billing.create", "billing.admin"],
          <Billing />
        )}
      >
        <Route path="general" element={<General />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="reports" element={<ReportsBilling />} />
        <Route path="config" element={<Config />} />
      </Route>

      <Route
        path="/*"
        element={
          !cookies.token || cookies.token === "" ? (
            <Navigate to="/login" />
          ) : (
            <Page404 />
          )
        }
      />
    </>
  );

  const router = createBrowserRouter(routes, { basename: baseNameFromEnv });
  return (
    <div
      style={{
        background: `url(${backgroundImage})`,
        height: "100vh",
        width: "100vw",
        WebkitBackgroundSize: "cover",
        MozBackgroundSize: "cover",
        OBackgroundSize: "cover",
        backgroundSize: "cover",
      }}
    >
      <Modal
        isOpen={shouldChagePassword && cookies.token}
        style={customStylesModalChangePassword}
        contentLabel="Change Password"
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Establecimiento de contraseña
          </div>{" "}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "10px 0",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
                textAlign: "start",
                margin: "0 0 10px 2px",
              }}
            >
              Debido a que la contraseña actual es provisional o ha sido
              restablecida recientemente por un administrador, te solicitamos
              establecer una nueva.
            </p>
            <label
              htmlFor="passwordUserNew"
              style={{
                width: "65%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                margin: "10px 0",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Contraseña nueva
              </p>

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  onChange={(e) => {
                    const value = e.target.value;

                    let error = "";
                    if (value.length <= 8) {
                      error = "La contrasena debe tener al menos 8 caracteres";
                    } else if (
                      !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)
                    ) {
                      error =
                        "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())";
                    } else if (!/[0-9]/.test(value)) {
                      error =
                        "La contrasena debe contener por lo menos un número";
                    }

                    dispatch(
                      changePasswordData({
                        ...passwordData,
                        newPassword: value,
                      })
                    );
                    dispatch(
                      changePasswordErrorData({
                        ...passwordDataError,
                        newPasswordError: error,
                      })
                    );
                  }}
                  id="passwordUserNew"
                  name="passwordUserNew"
                  type={showPasswordNew ? "text" : "password"}
                  placeholder="Contraseña segura"
                  value={passwordData.newPassword}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 32px 8px 8px", // Add space for icon
                    minHeight: "24px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />

                {/* Toggle Visibility Icon */}
                <span
                  onClick={() => setShowPasswordNew((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#000",
                  }}
                >
                  <Tooltip text={showPasswordNew ? "Ocultar" : "Mostrar"}>
                    {showPasswordNew ? (
                      <EyeIcon width={"25px"} height={"25px"} />
                    ) : (
                      <EyeOffIcon width={"25px"} height={"25px"} />
                    )}
                  </Tooltip>
                </span>
              </div>

              {passwordDataError.newPasswordError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {passwordDataError.newPasswordError}
                </p>
              )}
            </label>

            <label
              htmlFor="passwordUserNewRepeat"
              style={{
                width: "65%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                margin: "10px 0",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Confirma la contraseña nueva
              </p>

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  onChange={(e) => {
                    const value = e.target.value;

                    let error = "";
                    if (value.length <= 8) {
                      error = "La contrasena debe tener al menos 8 caracteres";
                    } else if (
                      !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)
                    ) {
                      error =
                        "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())";
                    } else if (!/[0-9]/.test(value)) {
                      error =
                        "La contrasena debe contener por lo menos un número";
                    }

                    dispatch(
                      changePasswordData({
                        ...passwordData,
                        newPasswordRepeat: value,
                      })
                    );
                    dispatch(
                      changePasswordErrorData({
                        ...passwordDataError,
                        newPasswordRepeatError: error,
                      })
                    );
                  }}
                  id="passwordUserNewRepeat"
                  name="passwordUserNewRepeat"
                  type={showPasswordRepeat ? "text" : "password"}
                  placeholder="Ingresa de nuevo la contraseña"
                  value={passwordData.newPasswordRepeat}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 32px 8px 8px", // space for icon
                    minHeight: "24px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />

                {/* Toggle Icon */}
                <span
                  onClick={() => setShowPasswordRepeat((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#000",
                  }}
                >
                  <Tooltip text={showPasswordRepeat ? "Ocultar" : "Mostrar"}>
                    {showPasswordRepeat ? (
                      <EyeIcon width={"25px"} height={"25px"} />
                    ) : (
                      <EyeOffIcon width={"25px"} height={"25px"} />
                    )}
                  </Tooltip>
                </span>
              </div>

              {passwordDataError.newPasswordRepeatError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {passwordDataError.newPasswordRepeatError}
                </p>
              )}
            </label>

            {(generalPasswordError || passwordDataError.oldPasswordError) && (
              <p
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  margin: "0 0 2px 2px",
                  fontWeight: "500",
                  color: "#cf4259",
                }}
              >
                {generalPasswordError || passwordDataError.oldPasswordError}
              </p>
            )}
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
                textAlign: "start",
                margin: "10px 0 20px 2px",
              }}
            >
              Recuerda almacenarla de forma segura, y en caso de olvidarla
              podrás recuperarla utilizando 'Olvide mi contraseña' en el inicio
              de sesión.
            </p>
            <button
              disabled={
                !canChangePassword() || passwordResetLoading === "pending"
              }
              onClick={(e) => {
                e.preventDefault();
                dispatch(resetOwnPassword()).then(() => {
                  dispatch(getClientAndUserData());
                });
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "35%",
                height: "40px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {passwordResetLoading === "pending" ? (
                <ClipLoader color="white" size={"20px"} />
              ) : (
                "Cambiar contraseña"
              )}
            </button>
          </div>
        </div>
      </Modal>
      <RouterProvider router={router} />
    </div>
  );
}

function redirectBasedOnRolesOrCookies(
  cookies: { token?: any },
  roles: string[],
  allowedRoles: string[],
  routeComponent: JSX.Element
) {
  if (!cookies.token || cookies.token === "") {
    return <Navigate to="/login" />;
  }
  for (const allowedRole of allowedRoles) {
    if (roles.includes(allowedRole)) {
      return routeComponent;
    }
  }
  return <Navigate to="/" />;
}

export default App;
